/* "Talk to us" — a quiet human escape hatch under FAQ sections.
   Uses the platform CONTACT_EMAIL (via /api/public/config) unless an
   explicit email is passed (microsites pass the organizer's address). */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";

import { api } from "@/lib/api";

let cachedConfig = null;

export const TalkToUs = ({ email, testid = "talk-to-us" }) => {
  const { t } = useTranslation();
  const [platformEmail, setPlatformEmail] = useState(cachedConfig?.contact_email || null);

  useEffect(() => {
    if (email || cachedConfig) return;
    api
      .get("/public/config")
      .then(({ data }) => {
        cachedConfig = data;
        setPlatformEmail(data.contact_email);
      })
      .catch(() => {});
  }, [email]);

  const target = email || platformEmail;
  if (!target) return null;

  return (
    <div
      data-testid={testid}
      className="mt-10 rounded-2xl border border-black/[0.06] bg-[#F9F9F8] px-6 sm:px-8 py-7 flex flex-col sm:flex-row sm:items-center gap-5"
    >
      <div className="w-11 h-11 rounded-full bg-[#1D4D3B]/10 flex items-center justify-center shrink-0" aria-hidden="true">
        <Mail className="w-5 h-5 text-[#1D4D3B]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-semibold text-[#0A0A0A]">{t("faq.talkTitle")}</p>
        <p className="text-sm text-[#737373] mt-0.5">{t("faq.talkDesc")}</p>
      </div>
      <a
        href={`mailto:${target}`}
        data-testid={`${testid}-mailto`}
        className="shrink-0 inline-flex items-center justify-center gap-2 h-11 px-6 rounded-full bg-[#0A0A0A] text-white text-sm font-medium hover:bg-black/80 transition-colors duration-300"
      >
        {t("faq.talkCta")}
      </a>
    </div>
  );
};
